import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Formik, Form, Field } from 'formik';
import { loading, getRoute, verifyOwnerPin } from '../../../actions/sessions';
import { asyncActions } from  '../../../actions/general';
import Loading from '../../shared/Loading';
import Error from '../../shared/Error';

let refs = [];

const getRefs = refs => {
  return refs.filter(r => r.current);
}

const autoTab = e => {
  const BACKSPACE_KEY = 8;
  const TAB_KEY = 9;
  const DELETE_KEY = 46;
  const index = Number(e.target.getAttribute('data-index')) || 0;

  let nextElem;

  const finalRefs = getRefs(refs);

  if (e.keyCode === BACKSPACE_KEY) {
    nextElem = index > 0 && finalRefs[index - 1];
  } else if (e.keyCode !== DELETE_KEY && e.keyCode !== TAB_KEY) {
    nextElem = index < finalRefs.length - 1 && finalRefs[index + 1];
  }

  if (nextElem && nextElem.current) {
    nextElem.current.focus();
  }
}

const Input = props => {
  const ref = useRef(null);
  refs.push(ref);

  if (props.index < 1) {
    return (
      <Field
        autoFocus
        className="input"
        data-index={props.index}
        role={'token' + props.index}
        type="text"
        id={'token' + props.index}
        name={'token' + props.index}
        onKeyUp={props.autoTab}
        innerRef={ref}
        maxLength="1"
        placeholder="0" />
    )
  }

  return (
    <Field
      className="input"
      data-index={props.index}
      role={'token' + props.index}
      type="text"
      id={'token' + props.index}
      name={'token' + props.index}
      onKeyUp={props.autoTab}
      innerRef={ref}
      maxLength="1"
      placeholder="0" />
  )
}

const inputs = Array.from({ length: 6 }, (element, index) => (
  <div key={index} className="column">
    <div className="field">
      <div className="control">
        <Input index={index} autoTab={autoTab} />
      </div>
    </div>
  </div>
));

export default function OwnerPin({ match }) {
  const dispatch = useDispatch();
  const isLoading = useSelector(state => state.sessions.get('loading'));
  const [token, setToken] = useState('');
  const [error, setError] = useState(false);
  const formRef = useRef(null);

  const checkToken = async val => {
    const res = await dispatch(verifyOwnerPin(val));
    return res;
  }

  const onKeyDown = e => {
    if ((e.charCode || e.keyCode) === 13) {
      e.preventDefault();
    }
  }

  const makeToken = values => values.token0 + values.token1 + values.token2 + values.token3 + values.token4 + values.token5;

  const save = (values, verified) => {
    dispatch(asyncActions(
      getRoute(),
      getRoute()
    ))
    .then(() => dispatch(loading(false)));
  }

  useEffect(() => {
    if (token.length === 6) {
      formRef.current.handleSubmit();
    }
  }, [token]);

  return (
    <div role="form">
      <div className="subtitle has-text-weight-semibold has-text-centered">For your security, please enter in the 6-digit code in the email from Credit Key</div>

      <Error />

      <Formik
        innerRef={formRef}
        initialValues={{
          token0: '',
          token1: '',
          token2: '',
          token3: '',
          token4: '',
          token5: ''
        }}
        validate={async (values) => {
          const errors = {};
          const token = makeToken(values);

          setToken(token);
          setError(false);

          return errors;
        }}
        onSubmit={async (values, { setSubmitting, setStatus, resetForm } ) => {
          dispatch(loading(true));
          const verified = await checkToken(token);

          if (verified.data.attributes.authorized) {
            save(values, verified);
          } else {
            refs = [];
            setToken('');
            setError(true);
            resetForm();
            dispatch(loading(false));
          }
        }}
      >
        {({ isSubmitting }) => (
          <>
            {isLoading && <Loading active={true} />}

            {!isLoading && <Form onKeyDown={onKeyDown}>
              <div className="columns is-mobile tokens">
                {inputs}
              </div>

              {error && <div role="error" className="notification is-danger has-text-centered">Invalid token</div>}
            </Form>}
          </>
        )}
      </Formik>
    </div>
  )
}
